// extracted by mini-css-extract-plugin
export default {"Row":"NumPad_Row__ACHiB","Button":"NumPad_Button__JUeog"};